import showCustomAlert from './containers/UtilityComponent/ConfirmAlertWrapper';
// import "react-confirm-alert/src/react-confirm-alert.css";

let sessionTimeout;
let warningTimeout;
let timerInterval;
let setDisplayTimer;

// Duration values
const sessionDuration = 30 * 60 * 1000; // 30 minutes
const warningDuration = 5 * 60 * 1000;  // 5 minutes before expiry

// const sessionDuration = 1 * 60 * 1000; // 1 minutes for testing
// const warningDuration = 1 * 30 * 1000;  // 30sec before expiry

// Function to start the session timer
export function startSessionTimer(displayTimerCallback) {

    clearTimeout(sessionTimeout);
    clearTimeout(warningTimeout);
    clearInterval(timerInterval);
    setDisplayTimer = displayTimerCallback; // Store the callback
    // Notify user 5 minute before session expiry
    warningTimeout = setTimeout(() => {
        notifyUserOfSessionExpiry();
    }, sessionDuration - warningDuration);

    // Session expiry logic (handled server-side)
    sessionTimeout = setTimeout(() => {
        // Show the alert message
        showCustomAlert({
            message: "Your session has expired. Please log in again.",
            buttons: [
                {
                    label: "OK",
                    className: "confirmBtn",
                    onClick: () => {
                        sessionStorage.clear();
                        stopSessionTimer();
                        window.location.href = "/login";
                    },
                }
            ]
        });
        clearInterval(timerInterval);
    }, sessionDuration);
}

// Function to reset the session timer after each API call
export function resetSessionTimer() {
    console.log("Reset Me");
    startSessionTimer(setDisplayTimer); // Restart the timer and pass the callback
    if (setDisplayTimer) setDisplayTimer(null); // Hide timer on API call
}

// Function to stop the session timer
export function stopSessionTimer() {
    clearTimeout(sessionTimeout);
    clearTimeout(warningTimeout);
    clearInterval(timerInterval);
}

// Notify user of session expiry and display a countdown timer
function notifyUserOfSessionExpiry() {
    let timeRemaining = warningDuration / 1000;
    timerInterval = setInterval(() => {
        if (timeRemaining > 0) {
            timeRemaining--;
            // Display the timer in HH:MM:SS format
            const formattedTime = formatTime(timeRemaining);
            if (setDisplayTimer) setDisplayTimer(formattedTime);
        } else {
            // When the timer reaches 0
            clearInterval(timerInterval);
            if (setDisplayTimer) setDisplayTimer("00:00:00"); // Ensure it shows 00:00:00
        }
    }, 1000);
    // Show the alert message
    showCustomAlert({
        message: "Your session will expire in 5 minutes",
        buttons: [
            {
                label: "OK",
                className: "confirmBtn"
            }
        ]
    });
}

// Helper function to format time in HH:MM:SS
function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return [hours, minutes, secs]
        .map(unit => String(unit).padStart(2, '0')) // Ensures two-digit format
        .join(':');
}